import { reduce } from "lodash";
import { create } from "zustand";

import { Song } from "../types/song.types";

interface FavoriteSongStore {
  songs: object;
  setSongs: (songs: Song[]) => void;
  setFavouriteToSong: (songId: string) => void;
  removeFavouriteFromSong: (songId: string) => void;
}

const favoriteSongStore = create<FavoriteSongStore>((set) => ({
  songs: new Set<Song>(),

  setSongs: (songs: Song[]) => {
    const objectToStore = reduce(
      songs,
      (acc, song) => ({
        ...acc,
        [song.id]: true,
      }),
      {}
    );
    set({ songs: objectToStore });
  },

  setFavouriteToSong: (songId: string) => {
    set((state) => {
      const status = !state.songs[songId];
      const updatedObject = { ...state.songs, [songId]: status };
      return { songs: updatedObject };
    });
  },

  removeFavouriteFromSong: (songId: string) => {
    set((state) => {
      const updatedObject = { ...state.songs, [songId]: false };
      return { songs: updatedObject };
    });
  },
}));

export default favoriteSongStore;
